import { AlertController, Events, LoadingController, NavParams,ToastController } from 'ionic-angular';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { AppDialog } from '../../component/appDialog';
import { LotteryService } from '../../services/lottery.services';
import { HomePage } from '../home/home';
import { BancaServices } from '../../services/banca.services';
import { ThirdpartyGamesServices } from '../../services/thirdGame.services';
import { UserService } from '../../services/user.services';

@Component({
    templateUrl: 'fundTransfer.html',
    selector: 'fund-transfer-page',
})
export class FundTransferPage implements OnInit {
    @ViewChild('moneyItem') moneyItem: ElementRef;

    private mdAccountFrom: any;
    private mdAccountTo: any;

    private balanceTotal: any = 0;

    private moneyTransfer: string;
    private loading: any;

    private dataItemToggerFund: any = {};

    private transferList: any[];
    private balance: string = '0';
    tabList: any[] = [];
    menuList: any[] = [];
    livefblist: any[];
    tabSelect: string = 'sport';

    configGameMenuItems: any[] = [];
    configGameMenuItemsShow: any[] = [];
    configMenuItems: any[] = [];
    private thirdpartyGamesList: any[];
    gameSelect: string = '';

    private objChips = [
        {chipVal: "200", chipName: "200K"},
        {chipVal: "500", chipName: "500K"},
        {chipVal: "1000", chipName: "1M"},
        {chipVal: "2000", chipName: "2M"},
        {chipVal: "5000", chipName: "5M"},
        {chipVal: "10000", chipName: "10M"},
        {chipVal: "20000", chipName: "20M"},
        {chipVal: "50000", chipName: "50M"},

    ];


    constructor(
        private navParams: NavParams,
        private loadingCtrl: LoadingController,
        private cs: CommonService,
        private alertCtrl: AlertController,
        private events: Events,
        private lotteryService: LotteryService,
        private userService: UserService,
        private commonSV: CommonService,
        private toastCtrl: ToastController,
        private thirdpartyGamesServices: ThirdpartyGamesServices
    ) {}

    ngOnInit() {}

    ionViewWillEnter() {
        this.getTransferList();
        this.loadMainBalance();

    }

    chooseChip(item) {
        this.moneyTransfer = this.commonSV.numberWithCommas(item.chipVal*1000);

    }

    getTransferList() {
        this.thirdpartyGamesServices.transferInit({}, this.alertCtrl).then((data) => {
            this.transferList = data['fromList'];
            this.mdAccountFrom = data['fromSelectedValue'];
            this.mdAccountTo = data['toSelectedValue'];
            this.balanceTotal = data['totalAmount'];
            this.configMenuItems = data['configMenuItems'];
            this.configGameMenuItems = data['configGameMenuItems'];
            this.handleChangeTab(this.tabSelect);
        });
    }
    loadMainBalance() {
        this.lotteryService.getBalance((data) => {
            this.balance = this.cs.numberWithCommas(data['balance']);
        });
    }

    loadTabGame() {
        this.userService.initHome(undefined, this.alertCtrl).then((data) => {
            if (data['msg'] == '') {
                HomePage.zaloID = data['zaloID'];
                this.tabList = data['tabList'];
                this.menuList = data['menuList'];
                this.filterTabMatch(this.tabSelect);
            }
        });
    }

    handleChangeTab(tabValue: any) {
        this.tabSelect = tabValue;
        this.filterTabMatch(tabValue);
        this.gameSelect=this.configGameMenuItemsShow[0].providercode;
        this.handleGameChange(this.gameSelect);
    }

    handleGameChange(gameValue: any) {
        console.log("handleGameChange:",gameValue);
        
        this.gameSelect = gameValue;

    }



    filterTabMatch(tabSelect: string) {
        //filter thirdgame party list
        console.log("vao ", tabSelect);
        
        this.configGameMenuItemsShow =  this.configGameMenuItems.filter((item) => item.type === tabSelect); 
    }



    slFromChange(ev: any) {
        if (ev !== '1') {
            this.mdAccountTo = '1';
        }
    }

    slToChange(ev: any) {
        if (ev !== '1') {
            this.mdAccountFrom = '1';
        }
    }

    updateMoneyKeyUp(ev: any) {
        let getMoneyRegx = ev.replace(/[,]/g, '');
        this.moneyTransfer = this.cs.numberWithCommas(Number(getMoneyRegx));
        this.moneyTransfer === '0' ? (this.moneyItem.nativeElement.value = '') : (this.moneyItem.nativeElement.value = this.moneyTransfer);
    }

    transferMoney() {
        let x=true;
        if (x) {
            AppDialog.toast({
                toastCtrl: this.toastCtrl,
                message: 'Comming Soon',
            });
            return;
         }

        if (this.moneyTransfer === '' || /[^0-9,]/g.test(this.moneyTransfer)) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: 'Số tiền không hợp lệ !!!',
            });
        } else {
            let direction;
            if (this.mdAccountTo === '1') {
                // withdraw
                direction = 1;
            } else if (this.mdAccountFrom === '1') {
                // deposit
                direction = 0;
            }
            const keyGameTransfer = direction === 1 ? this.mdAccountFrom : this.mdAccountTo;
            this.submitFundTransfer(keyGameTransfer, direction);
        }
    }

    submitFundTransfer(keyGameTransfer: string, direction: number) {
        //direction :0 => deposit, 1: withdrawl

        let params = {
            direction: direction,
            amount: Number(this.moneyTransfer.replace(/[,]/g, '')),
        };

        this.thirdpartyGamesServices.transferBalance(params, keyGameTransfer, this).then((data) => {
            if (data.hasOwnProperty('msg') && data['msg'] !== '') {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data['msg'],
                });
                return;
            }
            if (data['msg'] === '') {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: 'Giao dịch thành công',
                    callBack: () => {
                        this.moneyTransfer = '';
                        this.getTransferList();
                    },
                });
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data['msg'],
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/fundTransfer/fundTransfer.ts